<!-- index.vue -->
<template>
    <ion-toolbar>
      <ion-buttons slot="start">
      <ion-button class="toolbar-button" @click="jobSeekerDrawer = true">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M15.5583 1.6665H13.975C12.1583 1.6665 11.2 2.62484 11.2 4.4415V6.02484C11.2 7.8415 12.1583 8.79984 13.975 8.79984H15.5583C17.375 8.79984 18.3333 7.8415 18.3333 6.02484V4.4415C18.3333 2.62484 17.375 1.6665 15.5583 1.6665Z"
            fill="black" />
          <path
            d="M6.03341 11.1919H4.45008C2.62508 11.1919 1.66675 12.1502 1.66675 13.9669V15.5502C1.66675 17.3752 2.62508 18.3336 4.44175 18.3336H6.02508C7.84175 18.3336 8.80008 17.3752 8.80008 15.5586V13.9752C8.80841 12.1502 7.85008 11.1919 6.03341 11.1919Z"
            fill="black" />
          <path
            d="M5.24175 8.8165C7.21617 8.8165 8.81675 7.21592 8.81675 5.2415C8.81675 3.26709 7.21617 1.6665 5.24175 1.6665C3.26733 1.6665 1.66675 3.26709 1.66675 5.2415C1.66675 7.21592 3.26733 8.8165 5.24175 8.8165Z"
            fill="black" />
          <path
            d="M14.7583 18.3331C16.7328 18.3331 18.3333 16.7325 18.3333 14.7581C18.3333 12.7837 16.7328 11.1831 14.7583 11.1831C12.7839 11.1831 11.1833 12.7837 11.1833 14.7581C11.1833 16.7325 12.7839 18.3331 14.7583 18.3331Z"
            fill="black" />
        </svg>
      </ion-button>
    </ion-buttons>
      <ion-title>
        <img v-if="isAustralia" :src="require('@/assets/img/toolbar-logo.png')" :alt="$filters.appName()">
        <img v-if="isUS" :src="require('@/assets/img/us/toolbar-logo-us.png')" :alt="$filters.appName()">
      </ion-title>
      <ion-buttons slot="end">
        <ion-button class="notifications_button toolbar-button" @click="notifications">
          <!-- <i class="locumate_icons locumate_icon-notification_bell"></i> -->
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.1168 12.0748L15.2834 10.6915C15.1084 10.3832 14.9501 9.79984 14.9501 9.45817V7.34984C14.9501 5.3915 13.8001 3.69984 12.1418 2.90817C11.7084 2.1415 10.9084 1.6665 9.99178 1.6665C9.08345 1.6665 8.26678 2.15817 7.83345 2.93317C6.20845 3.7415 5.08345 5.4165 5.08345 7.34984V9.45817C5.08345 9.79984 4.92511 10.3832 4.75012 10.6832L3.90845 12.0748C3.57512 12.6332 3.50012 13.2498 3.70845 13.8165C3.90845 14.3748 4.38345 14.8082 5.00012 15.0165C6.61678 15.5665 8.31678 15.8332 10.0168 15.8332C11.7168 15.8332 13.4168 15.5665 15.0334 15.0248C15.6168 14.8332 16.0668 14.3915 16.2834 13.8165C16.5001 13.2415 16.4418 12.6082 16.1168 12.0748Z" fill="black"/>
            <path d="M12.3582 16.6748C12.0082 17.6415 11.0832 18.3332 9.9999 18.3332C9.34157 18.3332 8.69157 18.0665 8.23324 17.5915C7.96657 17.3415 7.76657 17.0082 7.6499 16.6665C7.75824 16.6832 7.86657 16.6915 7.98324 16.7082C8.1749 16.7332 8.3749 16.7582 8.5749 16.7748C9.0499 16.8165 9.53324 16.8415 10.0166 16.8415C10.4916 16.8415 10.9666 16.8165 11.4332 16.7748C11.6082 16.7582 11.7832 16.7498 11.9499 16.7248C12.0832 16.7082 12.2166 16.6915 12.3582 16.6748Z" fill="black"/>
          </svg>
          <el-badge is-dot class="item" v-if="unreadNotifications"></el-badge>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  
    <div class="main_wrapper ion-padding">
      <div class="container">
        <ApplicationsComponent />
      </div>
    </div>

    <el-drawer class="job-seeker-profile" custom-class="job-seeker-profile" direction="ttb" v-model="jobSeekerDrawer"
        :show-close="true" append-to-body="true">
        <div class="job-seeker-profile-wrapper">
          <div class="profile-top">
            <div class="image" v-if="user.image">
              <img :src="user.image" alt="profile" />
            </div>
            <div class="image" v-else>
             <el-avatar  :size="'large'" :shape="'square'" icon="el-icon-user-solid"></el-avatar>
           </div>
            <div class="details">
              <h3>{{ user.name ? user.name : 'N/A' }}</h3>

              <!-- <p>{{ $filters.userRoleConversion(user) }}</p> -->
               <p>{{ user.platformRole }}</p>
            </div>
          </div>
          <div>
            <div class="setting-item">
              <div class="setting-item__icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10 9.99996C12.3012 9.99996 14.1667 8.13448 14.1667 5.83329C14.1667 3.53211 12.3012 1.66663 10 1.66663C7.69885 1.66663 5.83337 3.53211 5.83337 5.83329C5.83337 8.13448 7.69885 9.99996 10 9.99996Z"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path
                    d="M16.0083 13.1167L13.0583 16.0667C12.9416 16.1834 12.8333 16.4 12.8083 16.5584L12.6499 17.6833C12.5916 18.0917 12.875 18.375 13.2833 18.3167L14.4083 18.1583C14.5666 18.1333 14.7916 18.025 14.9 17.9084L17.8499 14.9584C18.3583 14.45 18.5999 13.8583 17.8499 13.1083C17.1083 12.3667 16.5166 12.6083 16.0083 13.1167Z"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M15.5833 13.5416C15.8333 14.4416 16.5332 15.1416 17.4332 15.3916"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M2.84167 18.3333C2.84167 15.1083 6.05003 12.5 10 12.5C10.8667 12.5 11.7 12.625 12.475 12.8583"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>

              </div>
              <div class="setting-item__content" @click="links.changeJobSeekerAdditional">
                <div class="setting-item__title">
                  Account
                </div>
                <div class="setting-item__description">
                  Update your account settings
                </div>
              </div>
            </div>
            <!-- <div class="setting-item">
                    <div class="setting-item__icon">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.3083 7.3999H14.6834" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M5.31665 7.3999L5.94165 8.0249L7.81665 6.1499" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M10.3083 13.2334H14.6834" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M5.31665 13.2334L5.94165 13.8584L7.81665 11.9834" stroke="rgb(var(--locumate-primary-color))"
                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M7.49996 18.3334H12.5C16.6666 18.3334 18.3333 16.6667 18.3333 12.5001V7.50008C18.3333 3.33341 16.6666 1.66675 12.5 1.66675H7.49996C3.33329 1.66675 1.66663 3.33341 1.66663 7.50008V12.5001C1.66663 16.6667 3.33329 18.3334 7.49996 18.3334Z"
                                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>



                    </div>
                    <div class="setting-item__content" @click="links.goToMyApplications">
                        <div class="setting-item__title">
                            My Applications
                        </div>
                        <div class="setting-item__description">
                            View your applications
                        </div>
                    </div>
                </div> -->
            <div class="setting-item">
              <div class="setting-item__icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.75836 12.2501L9.00836 13.5001L12.3417 10.1667" stroke="rgb(var(--locumate-primary-color))"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M8.33335 5.00008H11.6667C13.3334 5.00008 13.3334 4.16675 13.3334 3.33341C13.3334 1.66675 12.5 1.66675 11.6667 1.66675H8.33335C7.50002 1.66675 6.66669 1.66675 6.66669 3.33341C6.66669 5.00008 7.50002 5.00008 8.33335 5.00008Z"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M13.3333 3.3501C16.1083 3.5001 17.5 4.5251 17.5 8.33343V13.3334C17.5 16.6668 16.6667 18.3334 12.5 18.3334H7.5C3.33333 18.3334 2.5 16.6668 2.5 13.3334V8.33343C2.5 4.53343 3.89167 3.5001 6.66667 3.3501"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>


              </div>
              <div class="setting-item__content" @click="links.goToPreviousApplications">
                <div class="setting-item__title">
                  Previous Jobs
                </div>
                <div class="setting-item__description">
                  View your previous jobs
                </div>
              </div>
            </div>
            <div class="setting-item">
              <div class="setting-item__icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M18.3334 8.33341V12.5001C18.3334 16.6667 16.6667 18.3334 12.5 18.3334H7.50002C3.33335 18.3334 1.66669 16.6667 1.66669 12.5001V7.50008C1.66669 3.33341 3.33335 1.66675 7.50002 1.66675H11.6667"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M18.3334 8.33341H15C12.5 8.33341 11.6667 7.50008 11.6667 5.00008V1.66675L18.3334 8.33341Z"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M5.83331 10.8333H10.8333" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M5.83331 14.1667H9.16665" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <div class="setting-item__content" @click="links.goToTermsAndConditions">
                <div class="setting-item__title">
                  Terms & Conditions
                </div>
                <div class="setting-item__description">
                  View Terms & Conditions
                </div>
              </div>
            </div>
            <div class="setting-item">
              <div class="setting-item__icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M18.3084 15.2751C18.3084 15.5751 18.2417 15.8834 18.1001 16.1834C17.9584 16.4834 17.7751 16.7667 17.5334 17.0334C17.1251 17.4834 16.6751 17.8084 16.1667 18.0167C15.6667 18.2251 15.1251 18.3334 14.5417 18.3334C13.6917 18.3334 12.7834 18.1334 11.8251 17.7251C10.8667 17.3167 9.90842 16.7667 8.95842 16.0751C8.00008 15.3751 7.09175 14.6001 6.22508 13.7417C5.36675 12.8751 4.59175 11.9667 3.90008 11.0167C3.21675 10.0667 2.66675 9.11675 2.26675 8.17508C1.86675 7.22508 1.66675 6.31675 1.66675 5.45008C1.66675 4.88341 1.76675 4.34175 1.96675 3.84175C2.16675 3.33341 2.48341 2.86675 2.92508 2.45008C3.45841 1.92508 4.04175 1.66675 4.65841 1.66675C4.89175 1.66675 5.12508 1.71675 5.33341 1.81675C5.55008 1.91675 5.74175 2.06675 5.89175 2.28341L7.82508 5.00841C7.97508 5.21675 8.08341 5.40841 8.15841 5.59175C8.23341 5.76675 8.27508 5.94175 8.27508 6.10008C8.27508 6.30008 8.21675 6.50008 8.10008 6.69175C7.99175 6.88341 7.83341 7.08341 7.63341 7.28341L7.00008 7.94175C6.90841 8.03341 6.86675 8.14175 6.86675 8.27508C6.86675 8.34175 6.87508 8.40008 6.89175 8.46675C6.91675 8.53341 6.94175 8.58341 6.95842 8.63341C7.10842 8.90841 7.36675 9.26675 7.73341 9.70008C8.10841 10.1334 8.50841 10.5751 8.94175 11.0167C9.39175 11.4584 9.82508 11.8667 10.2667 12.2417C10.7001 12.6084 11.0584 12.8584 11.3417 13.0084C11.3834 13.0251 11.4334 13.0501 11.4917 13.0751C11.5584 13.1001 11.6251 13.1084 11.7001 13.1084C11.8417 13.1084 11.9501 13.0584 12.0417 12.9667L12.6751 12.3417C12.8834 12.1334 13.0834 11.9751 13.2751 11.8751C13.4667 11.7584 13.6584 11.7001 13.8667 11.7001C14.0251 11.7001 14.1917 11.7334 14.3751 11.8084C14.5584 11.8834 14.7501 11.9917 14.9584 12.1334L17.7167 14.0917C17.9334 14.2417 18.0834 14.4167 18.1751 14.6251C18.2584 14.8334 18.3084 15.0417 18.3084 15.2751Z"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10" />
                  <path
                    d="M15.4167 7.50016C15.4167 7.00016 15.025 6.2335 14.4417 5.6085C13.9083 5.0335 13.2 4.5835 12.5 4.5835"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M18.3333 7.50008C18.3333 4.27508 15.725 1.66675 12.5 1.66675"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>

              </div>
              <div class="setting-item__content">
                <a
            :href="supportLink"
            target="_blank"
            data-testid="support-btn"
          >
                <div class="setting-item__title">
                  Support Team
                </div>
                <div class="setting-item__description">
                  Get connected with the Support Team
                </div>
                </a>
              </div>
            </div>
          </div>
          <el-button class="text-only logout-btn" @click="links.logout">
            LOGOUT
          </el-button>
        </div>
      </el-drawer>
  </template>
    
  <script>
  import { useStore } from "vuex";
  import {
    useRouter,
  } from "vue-router";
  import { onMounted, inject, ref, computed  } from 'vue';
  import { addIcons } from 'ionicons';
  import { arrowBackOutline } from 'ionicons/icons';
  addIcons({
    'arrow-back-outline': arrowBackOutline,
  });
  import { IonToolbar, } from '@ionic/vue';
  import ApplicationsComponent  from './Component/ApplicationsComponent.vue';
//   import BrowseJobsComponent  from './Component/BrowseJobsComponent.vue';
  // import HistoryComponent from './Component/HistoryComponent.vue';
import { ElMessageBox } from "@/components/Vendor/Element";
import { isUSRegion } from '@/helpers/region/regionHelper.js';
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';
  
  export default {
    components: {
      IonToolbar,
    //   BrowseJobsComponent,
      ApplicationsComponent,
      // HistoryComponent
    },
    setup() {
      const $store = useStore();
      const $router = useRouter();
      const setPageClassGlobal = inject('setPageClassGlobal');
      const activeTab = ref('jobs');
      const currentRouteName = ref(null);
      const jobSeekerDrawer = ref(false);
      const mainMenuShow = inject("mainMenuShow");
      const user = $store.getters.GET_USER_DATA;
      const isAustralia = isAustraliaRegion();
      const isUS = isUSRegion();
      let supportLink = ref(null);

      const regex = /http:\/\/|https:\/\//gm;
    supportLink.value = user.supportSite.replace(regex, "");
    supportLink = `https://${supportLink.value}`;
     const links = {
      changeJobSeekerAdditional: () => {
        

        if (user.role === "locum") {
          $router.push({
            name: "profile_edit",
          });
        } else {
          $router.push({
            name: "basic_profile_job_seeker",
          });
        }
      },
      changeBasicProfileJobSeeker: () => {
        $router.push({
          name: "basic_profile_job_seeker",
        });
      },
      changePhoto: () => {
        $router.push({
          name: "profile_photo_job_seeker",
        });
      },
      notifications: () => {
        $router.push({
          name: "profile_notifications",
        });
      },
      goToAbout: () => {
        const link = document.getElementById("goToAboutPage");
        link.click();
      },

      goToTermsAndConditions: () => {
        $router.push({
          name: "terms_and_conditions",
        });
      },
      goToPreviousApplications: () => {
        $router.push({
          name: "job_seeker_previous_applications",
        });
      },
      goToMyApplications: () => {
        $router.push({
          name: "job_seeker_my_applications",
        });
      },
      goToPrivacyPolicy: () => {
        $router.push({
          name: "privacy_policy",
        });
      },

      logout: () => {
        (async () => {
          try {
            await ElMessageBox.confirm(
              ``,
              "Are you sure you want to log out?",
              {
                distinguishCancelAndClose: true,
                showConfirmButton: true,
                confirmButtonText: "Logout",
                cancelButtonText: "Cancel",
                confirmButtonClass: "el-button--green",
                cancelButtonClass: "el-button--grey",
                showClose: true,
              }
            );
          } catch {
            return;
          }
          try {
            await $store.dispatch("AUTH_LOGOUT");
          } catch (error) {
            console.log(error);
          }
        })();
      },
    };

      let previousRouteName = computed(() => {
        return $store.getters.PREVIOUS_ROUTE_NAME;
      });
      console.log("🚀 ~ setup ~ previousRouteName:", previousRouteName.value)

      const unreadNotifications = computed(() => {
        return $store.getters.GET_NOTIFICATIONS_DATA.unread;
      });
      
      
        const notifications = () => {
          $router.push({
            name: "notifications",
          });
        }
      

      const goNext = () => {
        $router.push({
          name: 'create_job_listing',
        });
      };
      const goBack = () => {
        $store.dispatch("clearJobCreatePageData");
        $router.push({
          name: "search",
        });
      };
  
      const handleTabClick = (tab) => {
        console.log("Tab clicked:", tab.props.name);
        currentRouteName.value = $router.currentRoute.value.name;
        console.log("🚀 ~ setup ~ currentRouteName.value:", currentRouteName.value)
        $store.dispatch('PREVIOUS_ROUTE_NAME', currentRouteName.value);
        activeTab.value = tab.props.name;
      };   
    
  
      onMounted(() => {
        setPageClassGlobal('global_job_poster_page');
        mainMenuShow(true);
        console.log("preeeeeee",previousRouteName.value)
        // if(previousRouteName.value == 'job_seeker_browse_filter'){
        //   activeTab.value = 'jobs'
        // }else if(previousRouteName.value == 'job_seeker_application_filter' || previousRouteName.value =='job_seeker_application_withdraw'){
        //   activeTab.value = 'applications'
        // }else if(previousRouteName.value == 'job_seeker_history_filter' || previousRouteName.value =='job_seeker_previous_application'){
        //   activeTab.value = 'history'
        // }else{
        //   activeTab.value = 'jobs'
        // }
      });
    
      return {
        goBack,
        goNext,
        activeTab,
        handleTabClick,
        unreadNotifications,
        notifications,
        jobSeekerDrawer,
        user,
        links,
        supportLink,
        isUS,
        isAustralia
      };
    },
  };
  </script>
    